<app-header bannerImage="horizon-sprayer.png"></app-header>
<h1>{{title}}</h1>



<h1 i18n="@@LiquidFertisaliserApplication">Liquid fertiliser application</h1>
<p i18n="@@adviceP1">To achieve the best results when using fertilisers, the nutrients have to be spread accurately and evenly and at the right rate across the whole spreader width. 
    A high quality fertiliser is important, but so is how you spread it!</p>


<h2 i18n="@@LiquidFertisaliserApplication">Liquid fertiliser application</h2>

<p i18n="@@adviceP2">Liquid fertiliser can be applied through an existing farm sprayer and can give an immediate improvement to the nutritional conditions of the crops.</p>

<ul>
    <li i18n="@@adviceList1">Application accuracy: Across the full boom width however wide, over the entire field with the correct amount applied per hectare, at the end of bouts by reducing overlaps and especially at the field margins right up to the crop’s edge - and no further.</li>
    <li i18n="@@adviceList2">Benefits include: More even crops, reduced overlapping on headlands, less fertiliser wastage, less risk of lodging and diseases, easier combining, more homogeneity and higher yields.</li>
</ul>

<p i18n="@@adviceP3">Find further information on YaraVita products</p>

<h2 i18n="@@YaraVitaFertiliser">YaraVita fertiliser application</h2>

<p i18n="@@adviceP4">YaraVita foliar spray products are widely tankmixable with other agrochemical 
    inputs to make treatment easier and more convenient. 
    At <a href="www.tankmix.com">www.tankmix.com</a> and in the Yara TankmixIT App you will find the results of more than 30.000 tank mix tests. The service is updated daily and is searchable by product or by active ingredient.</p>
<!--
 <div markdown [src]="sourcePath">
  
</div> 
-->